import React, { useState, useEffect, useRef } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
} from "reactstrap"
import Select from "react-select"
import { get, put, post } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useParams, useNavigate } from "react-router-dom"
import {
  UPDATE_DRIVER_EMERGENCIES,
  LANGUAGES_SEARCH,
  DRIVER_EMERGENCIES_SEARCH,
} from "helpers/api_endpoints"
import { Trans } from "react-i18next"
import moment from "moment"
import { useTranslation } from "react-i18next"

document.title = "Edit Emergency"

function EditDriverEmergency() {
  const { i18n } = useTranslation()
  const [loading, setLoading] = useState(true)
  const params = useParams()
  const [id, setId] = useState(params.id)
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState("")
  const navigate = useNavigate()
  const [emergency, setEmergency] = useState({})
  const [statuses, setStatuses] = useState([
    { value: "pending", label: "Pending" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
  ])

  useEffect(() => {
    let isMounted = true
    const getEmergencyType = async () => {
      setLoading(true)
      try {
        if (!params.id) {
          throw new Error("No emergency type ID provided")
        }

        const response = await post(`${DRIVER_EMERGENCIES_SEARCH}`, {
          id: params.id,
        })
        const data = response.data
        console.log("API Response:", emergency)

        if (data.id) {
          setId(data.id)
        }

        setEmergency(data)
        console.log("Emergency:", data)

        setLoading(false)
      } catch (error) {
        console.error("Error in getEmergencyType:", error)
        seterrorMsg(error.message || "Failed to load emergency type")
        setLoading(false)
      }
    }

    const getLanguages = async () => {
      setLoading(true)
      try {
        const response = await post(`${LANGUAGES_SEARCH}`, { status: 1 })
        const languages = response.data
        setLanguages(languages)
        setLoading(false)
      } catch (error) {
        console.log(error)
        seterrorMsg(error.message)
      }
    }
    getLanguages()
    getEmergencyType()

    return () => {
      isMounted = false
    }
  }, [params.id])

  const handleSubmit = async e => {
    e.preventDefault()
    
    // Only submit status, comments, and notes
    const submitData = {
      id: params.id,
      status: emergency.status,
      comments: emergency.comments,
      notes: emergency.notes
    }
    
    try {
        const response = await put(`${UPDATE_DRIVER_EMERGENCIES}`, submitData)
        const data = response.data
        console.log("API Response:", data)
        navigate("/driver-emergencies", {
          state: { successMsg: "Emergency Updated Successfully" },
        })
    } catch (error) {
        console.error("Error in handleSubmit:", error)
        seterrorMsg(error.message || "Failed to update emergency")
    }
  }

  const getTranslatedText = (titleData, defaultText = "") => {
    try {
      if (typeof titleData === "string") {
        try {
          const parsed = JSON.parse(titleData)
          if (Array.isArray(parsed?.title)) {
            const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
            const langKey = langMap[i18n.language] || 1
            const titleObj = parsed.title.find(item => item && item[langKey])
            return titleObj ? titleObj[langKey] : defaultText
          }
          return parsed.title || defaultText
        } catch (e) {
          return titleData || defaultText
        }
      }

      if (titleData && typeof titleData === "object") {
        return getTranslatedText(titleData.title, defaultText)
      }

      return defaultText
    } catch (error) {
      console.error("Error in getTranslatedText:", error)
      return defaultText
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Emergency Sub Type"
            breadcrumbItem="Edit Emergency Sub Type"
          />
          <Form className="form-horizontal" onSubmit={handleSubmit}>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {!params.id ? (
                        <Alert color="danger">
                          Error: No emergency ID provided in the URL
                        </Alert>
                      ) : null}
                      {errorMsg ? (
                        <Alert color="danger">{errorMsg}</Alert>
                      ) : null}
                    </Row>
                    <Row>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Driver Name</Trans>
                        </Label>
                        <Input
                          name="driverName"
                          value={emergency[0]?.driver?.name}
                          className="form-control"
                          placeholder="Enter Driver Name"
                          type="text"
                          required
                          disabled
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Partner</Trans>
                        </Label>
                        <Input
                          name="partnerName"
                          value={emergency[0]?.order?.partner?.name}
                          className="form-control"
                          placeholder="Enter Partner Name"
                          type="text"
                          required
                          disabled
                        />
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Partner Branch</Trans>
                        </Label>
                        <Input
                          name="partnerBranchName"
                          value={emergency[0]?.order?.partnerBranch?.name}
                          className="form-control"
                          placeholder="Enter Partner Name"
                          type="text"
                          required
                          disabled
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Order ID</Trans>
                        </Label>
                        <Input
                          name="orderId"
                          value={emergency[0]?.order?.id}
                          className="form-control"
                          placeholder="Enter Order ID"
                          type="text"
                          required
                          disabled
                        />
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Emergency Type</Trans>
                        </Label>
                        <Input
                          name="emergencyTypeId"
                          value={getTranslatedText(
                            emergency[0]?.emergencyType?.title
                          )}
                          className="form-control"
                          placeholder="Enter Order ID"
                          type="text"
                          required
                          disabled
                        />
                      </div>

                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Emergency Sub Type</Trans>
                        </Label>
                        <Input
                          name="emergencySubTypeId"
                          value={getTranslatedText(
                            emergency[0]?.emergencySubType?.title
                          )}
                          className="form-control"
                          placeholder="Enter Order ID"
                          type="text"
                          required
                          disabled
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <Select
                          name="status"
                          value={statuses.find(s => s.value === emergency.status)}
                          className="form-control"
                          placeholder="Select Status"
                          options={statuses}
                          onChange={selectedOption =>
                            setEmergency({
                              ...emergency,
                              status: selectedOption.value,
                            })
                          }
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Creation Time</Trans>
                        </Label>
                        <Input
                          name="creationTime"
                          value={emergency[0]?.creationTime}
                          className="form-control"
                          placeholder="Enter Creation Time"
                          type="text"
                          required
                          disabled
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Creation Date</Trans>
                        </Label>
                        <Input
                          name="creationDate"
                          value={moment(emergency.createdAt).format(
                            "YYYY-MM-DD"
                          )}
                          className="form-control"
                          placeholder="Enter Creation Date"
                          type="text"
                          required
                          disabled
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Note</Trans>
                        </Label>
                        <Input
                          name="notes"
                          value={emergency.notes || ''}
                          className="form-control"
                          placeholder="Enter Note"
                          type="text"
                          onChange={e =>
                            setEmergency({
                              ...emergency,
                              notes: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Comment</Trans>
                        </Label>
                        <Input
                          name="comments"
                          value={emergency.comments || ''}
                          className="form-control"
                          placeholder="Enter Comment"
                          type="text"
                          onChange={e =>
                            setEmergency({
                              ...emergency,
                              comments: e.target.value,
                            })
                          }
                          required
                        />
                      </div>
                    </Row>
                    <div className="text-center  mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default EditDriverEmergency
